<template>
  <h1
    class="text-rails-dark text-4xl font-extrabold tracking-tight break-words sm:text-5xl lg:text-6xl"
  >
    <slot></slot>
  </h1>
</template>
